import React, { useRef } from "react";
import { Link } from "react-router-dom";
import clicksound from "../components/music/click.mp3";

const ButtonPlay = ({ text, link, selectedCategory }) => {
  const audioRef = useRef(new Audio(clicksound));

  const handleClick = () => {
    audioRef.current.play();
  };

  return (
    <Link
      to={`${link}/${selectedCategory}`}
      className="start-button lg:px-7 lg:py-3 sm:px-4 sm:py-1 sm:text-sm lg:text-xl"
      onClick={handleClick}
    >
      {text}
    </Link>
  );
};

export default ButtonPlay;
